var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095967(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 120,
    viewBox: "0 0 167 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.4384 82.9751V115.545C79.4384 117.536 77.8331 119.15 75.8539 119.15H3.58443C1.60528 119.149 0 117.536 0 115.545V82.957C0 82.001 0.37804 81.0841 1.04934 80.409L36.8714 44.3844C38.2626 42.9853 40.5156 42.9755 41.9179 44.3634L78.3654 80.4048C79.0506 81.0827 79.437 82.0079 79.437 82.9751H79.4384Z",
    fill: "#EEFFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.999 39.6962V115.998C166.999 117.991 165.375 119.607 163.373 119.607H90.2827C88.281 119.606 86.6575 117.991 86.6575 115.998L86.6575 39.678C86.6575 38.7208 87.0398 37.8027 87.7188 37.1268L123.948 1.05694C125.355 -0.343874 127.633 -0.35367 129.052 1.03595L165.913 37.1226C166.606 37.8013 166.997 38.7278 166.997 39.6962H166.999Z",
    fill: "#EEFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095967);
export default __webpack_public_path__ + "static/media/frame-48095967.93e440431755330bc0ce22ee9abc2efc.svg";
export { ForwardRef as ReactComponent };